import { Theme } from "@nivo/theming";
import { colors } from "common/const/colors";

export const areaChartTheme = {
  axis: {
    ticks: {
      line: {
        strokeWidth: 0,
      },
      text: {
        fontSize: 16,
        fontWeight: 400,
        fill: colors.MidNavy,
        fontFamily: "Pretendard Variable",
        outlineColor: "transparent",
        outlineOpacity: 0,
        outlineWidth: 0,
      },
    },
  },
  crosshair: {
    line: {
      stroke: colors.MainBlue,
      strokeWidth: 1,
      strokeDasharray: "3, 3",
    },
  },
  dots: {
    background: colors.MainBlue,
    size: 8,
  },
};

export const barChartTheme = {
  axis: {
    ticks: {
      line: {
        strokeWidth: 0,
      },
      text: {
        fontSize: 16,
        fontWeight: 400,
        fill: colors.MidNavy,
        fontFamily: "Pretendard Variable",
        outlineColor: "transparent",
        outlineOpacity: 0,
        outlineWidth: 0,
      },
    },
  },
};
